// API client for Cloudflare Workers endpoints

// API base URL - defaults to localhost for development
const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:8787/api'

export interface TodayPuzzleResponse {
  date: string
  word?: {
    maskLength?: number
  }
  pic?: {
    id: number
    blurLevels?: number[]
  }
  rank?: {
    items: Array<{ id: string; label: string; value: number }>
  }
  sponsor?: {
    name: string
    logo_url: string
    link_url: string
    sponsor_text: string
  }
}

export interface PuzzleResponse {
  date: string
  word?: {
    answer: string
    allowed_guesses: string[]
  }
  pic?: {
    url: string
    canonical_answer: string
    aliases: string[]
  }
  rank?: {
    items: Array<{ id: string; label: string; value: number }>
    solution_order: string[]
  }
}

export async function fetchTodayPuzzle(): Promise<TodayPuzzleResponse> {
  const url = `${API_BASE}/today`
  console.log('Fetching puzzle from:', url)
  const response = await fetch(url)
  if (!response.ok) {
    const errorText = await response.text()
    console.error('API Error:', response.status, errorText)
    throw new Error(`Failed to fetch today's puzzle: ${response.statusText}`)
  }
  return response.json()
}

export async function fetchPuzzleByDate(date: string): Promise<PuzzleResponse> {
  const url = `${API_BASE}/puzzle/${date}`
  console.log('Fetching puzzle by date from:', url)
  const response = await fetch(url)
  if (!response.ok) {
    const errorText = await response.text()
    console.error('API Error:', response.status, errorText)
    throw new Error(`Failed to fetch puzzle: ${response.statusText}`)
  }
  return response.json()
}

export function getImageUrl(imageId: number): string {
  return `${API_BASE}/image/${imageId}`
}

// Helper to get image URL from puzzle response
export function getPicImageUrl(pic: { id: number; url?: string }): string {
  // If URL is provided directly, use it; otherwise use the image endpoint
  return pic.url || getImageUrl(pic.id)
}

